import { QueryHookOptions } from '@apollo/client';

import { useInfiniteQuery } from 'hooks/useInfiniteQuery';

import query from './accountsFiltersQuery.graphql';

export const useAccountsFiltersQuery = (
  options?: QueryHookOptions<
    ManagedPlatformAccountsFiltersQuery,
    ManagedPlatformAccountsFiltersQueryVariables
  >,
) => {
  return useInfiniteQuery<
    ManagedPlatformAccountsFiltersQuery,
    ManagedPlatformAccountsFiltersQueryVariables
  >(query, {
    fieldName: 'managedPlatformAccounts',
    ...options,
  });
};
